import ExamRequestModal from 'components/modals/exam_request_modal';
import './index.scss';

(function ($) {
  $('.js-btn-require-exam').on('click', (e) => {
    const data = $(e.currentTarget).data();
    ExamRequestModal.show(data, $(e.currentTarget));
  });
})(jQuery);
